<template>
<transition name="Loader">
  <div class="Loader">

    <div class="Loader__layer is-logo">
      <div class="Loader__title">
        <img :src="require('./img/title_' + lang + '.png')" />
      </div>
    </div>

    <div class="Loader__layer is-loader" v-if="!completed">
      <div class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>

    <transition @enter="enter" @leave="leave">    
      <div ref="button" class="Btn Loader__btn" @click="onClick()" v-if="completed && !clicked">{{ trans('start') }}</div>
    </transition>

    <div class="Loader__logo">
      <img :src="require('./img/logo.png')" />
    </div>
    <div class="Loader__logo-calq">
      <img :src="require('./img/logo-calq.png')" />
    </div>
  </div>
</transition>
</template>

<script>
import _ from 'lodash'
import TweenMax from 'gsap'
import Preloader from 'preload-js'
import configBuild from '@/../config/index.js'
import '@/commons/js/gsap/DrawSVGPlugin'

// import ambianceJSON from '@/components/sound/audio/ambiance.json'

import frJSON from '@/components/narration/audio/fr/momenta.json'
import enJSON from '@/components/narration/audio/en/momenta.json'


import {Howl, Howler} from 'howler'

const modeBuild = (process.env.NODE_ENV === 'production') ? 'build' : 'dev'

export default {
  data() {
    return {
      $preloader: null,
      resolveLoader: null,
      manifest: [],
      // ignore: ['js', 'css', 'mp4', 'webm', 'mp3', 'wav', 'zip', 'pdf', 'png', 'jpg', 'gif'],
      ignore: ['js', 'css', 'mp4', 'webm', 'zip', 'pdf', 'png', 'jpg', 'gif'],
      clicked: false,
      completed: false,
    }
  },
  translations: {
    fr: {
      start: 'Commencer'
    },
    en: {
      start: 'Start'
    }
  },
  computed: {
    promises() { return this.$store.getters['loader/promises'] },
    progress() { return this.$store.getters['loader/progress'] },
  },
  beforeDestroy() {
    this.$sound.stop()
    this.$sound.unload()
  },
  created() {
    document.body.addEventListener("touchstart", this.onTouch)
    this.$preloader = new createjs.LoadQueue()
    this.$http.get(configBuild[modeBuild].assetsPublicPath + 'manifest.json', { baseURL: '/' }).then(res => this.load(res.data))
  },
  methods: {
    loadSound() {
      this.$sound = (this.lang == 'fr') 
      ? new Howl({ src: [require('@/components/narration/audio/fr/momenta_fr.mp3')], sprite: frJSON.sprite })
      : new Howl({ src: [require('@/components/narration/audio/en/momenta_en.mp3')], sprite: enJSON.sprite })
      console.log('sound loaded '+ this.lang);
      Howler.mute(true)
    },
    onTouch() {
      this.$sound.play('sound_0')
      this.clicked = true 
    },
    enter(el, done) {
      done()
      TweenMax.to(el, .25, { alpha : 1, delay : .2})
    },
    leave(el, done) {
      done()
      this.$store.commit('loader/CLICKED') 
      this.$store.commit('loader/PROMISE_DEACTIVATE')
      this.$store.commit('loader/LOADER_LOADED')  
    },
    onClick() {
      this.clicked = true 
    },
    load(manifest) {
      this.$preloader.on('error', this._onLoadError)
      this.$preloader.on('progress', this._onLoadProgress)
      this.$preloader.on('complete', this._onLoadComplete)

      _.forEach(manifest, (file, key) => {
        let ext = file.substr(file.lastIndexOf('.') + 1)
        if(_.indexOf(this.ignore, ext) !== -1)
          return

        this.manifest.push({ id: key, src:  file })
      })

      let preloaderPromise = new Promise((resolve, reject) => {
        this.resolveLoader = resolve
        this.$preloader.loadManifest(this.manifest)
      })

      this.$store.commit('loader/PROMISE_PUSH', preloaderPromise)

      // this.faker(5)

      Promise.all(this.promises).then(this._onPromisesComplete)
    },
    faker(time) {
      let fakerPromise = new Promise((resolve, reject) => {
        TweenMax.delayedCall(time, resolve)
      })
      this.$store.commit('loader/PROMISE_PUSH', fakerPromise)
    },
    _onLoadProgress(event) {
      this.$store.commit('loader/SET_PROGRESS', { type: 'loader', value: event.progress })
    },
    _onLoadComplete(event) {
      this.resolveLoader('preloader resolded')
    },
    _onPromisesComplete(msg) {
      this.completed = true
      this.loadSound()
      // this.$store.commit('loader/PROMISE_DEACTIVATE')
      // this.$store.commit('loader/LOADER_LOADED')  
    },
    _onLoadError(event) {
      console.warn('ERROR IN LOADER')
    },
  }

}

</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Loader
  position fixed
  left  0
  right 0
  bottom 0
  top 0
  overflow hidden
  background black
  z-index 999999
  background-image url('./img/bg.jpg')
  background-size cover
  background-position center center
  transition opacity 2s
  &-enter
  &-leave-active
    opacity 0

  .spinner
    width 40px
    height 40px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    margin-top 150px

  .double-bounce1
  .double-bounce2
    width 100%
    height 100%
    border-radius 50%
    background-color green
    opacity 0.6
    position absolute
    top 0
    left 0
    animation sk-bounce 2.0s infinite ease-in-out

  .double-bounce2
    animation-delay -1.0s

  @keyframes sk-bounce {
    0%, 100% { transform: scale(0.0) } 50% { transform: scale(1.0) }
  }

  &__layer
    position fixed
    width 100vw
    height 100vh
    top 0px
    left 0px

    &.is-logo
      animation layer-logo 15s infinite ease-in-out

  @keyframes layer-logo { 0%, 100% { transform: scale(.9) } 50% { transform: scale(1) } }

  &__logo
  &__logo-calq
    width 200px
    position absolute
    bottom 50px
    left 50%
    transform translateX(-50%)
    img
      display block

  &__logo
    margin-left -110px

  &__logo-calq
    width 150px
    bottom 30px
    margin-left 110px

  &__title
    margin-top -20px
    position relative
    display block
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    width 700px

  &__line
    position absolute
    width 80vh
    height 80vh
    left 50%
    top 50%
    transform translate(-50%, -50%) rotate(-90deg)

    svg
      fill transparent
      stroke-width 3
      stroke white
      width 100%
      height 100%

  &__btn 
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    width 150px
    margin-top 150px
    padding 0
    transition opacity .5s
    transition-delay .5s
    opacity 0

    +max-screen-height(tablet-portrait)
      margin-top 184px
      height 36px
      width 144px
      line-height 38px !important

</style>



// WEBPACK FOOTER //
// src/components/loader/Loader.vue